// Client wrapper for the Worker's /api/delegation endpoint.

export type NsProbe = {
  host: string;
  ips: string[];
  serial?: number;
  status: "ok" | "no-address" | "unreachable" | "no-soa" | "not-probeable";
  message?: string;
};

export type DelegationReport = {
  domain: string;
  parentNs: string[] | null;
  parentSource: "rdap" | "unavailable";
  childNs: string[];
  probes: NsProbe[];
  findings: { level: "good" | "warn" | "info"; text: string }[];
};

export async function fetchDelegation(domain: string, signal?: AbortSignal): Promise<DelegationReport> {
  const res = await fetch(`/api/delegation?domain=${encodeURIComponent(domain)}`, { signal });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as DelegationReport;
}
